// extracted by mini-css-extract-plugin
export default {"linkContainer":"_GwyHD","linkBox":"_11Y_Z","selected":"_3frX_"};